export default {
	project: {
		my_xs: 'Minhas decisões',
		fields: {
			name: 'Título',
			name_explanation: 'Dê um título ao seu projeto',
			description: 'Missão',
			description_explanation: 'Declare sua missão geral',
			vision: 'Visão',
			vision_explanation: 'Declare a visão de longo prazo do projeto',
			description_long: 'Descrição',
			description_long_explanation: 'Ex.: «PME suíça de mecatrónica, 200 pessoas, mercado europeu de OEM automotor. Missão: tornar-se líder europeu em sensores inteligentes até 2030.»',
			description_long_hint: 'Quanto mais precisa for a descrição (setor, tamanho, missão), mais acurada será a análise.',
			description_long_warning_title: 'Descrição breve',
			description_long_warning_body: 'Sua descrição tem {{count}} caracteres. A IA pode inferir um setor ou contexto que não corresponde à sua organização. Deseja enriquecê-la antes de iniciar?',
			description_long_warning_enrich: 'Enriquecer',
			description_long_warning_continue: 'Iniciar mesmo assim',
			ai_context: 'Foco e ângulos específicos',
			ai_context_explanation: 'Indique os ângulos, atores ou restrições que a análise deve priorizar (ex. um concorrente específico, uma dimensão regulatória, um território, uma restrição temporal…).',
			fishbone_description: 'Plano estratégico - A ser',
			fishbone_description_explanation: '',
			reference: 'Referência',
			tags: 'Etiquetas',
			likelihoods: 'Probabilidades',
			impacts: 'Impactos',
			types: {
				stakeholders: 'Partes interessadas',
				stakeholders_long: 'Projeto partes interessadas',
				stakeholders_explanation: 'Alinhar as forças presentes',
				risks: 'Riscos',
				risks_long: 'Projeto riscos',
				risks_explanation: 'Transformar riscos em aberturas',
				pro: 'Execução da estratégia',
				pro_long: 'Projeto execução da estratégia',
				pro_explanation: 'Implementar com agilidade'
			},
			ai: {
				scenarios: {
					title: "Cenários a explorar",
					hint: "Processados pela IA privada — sem envio de dados para fora. Você pode editar o texto, o horizonte temporal, adicionar ou remover.",
					worst_label: "Pior caso",
					worst_default: "Os riscos maiores se concretizam, as aberturas são perdidas, as partes se opõem.",
					best_label: "Melhor caso",
					best_default: "Os riscos são geridos, as aberturas aproveitadas, as partes cooperam.",
					add: "Adicionar um cenário",
					remove: "Remover este cenário",
					label_placeholder: "Nome do cenário",
					content_placeholder: "Hipóteses, eventos-chave, condições de realização…"
				},
				horizon_unit: {
					d: "dias",
					w: "semanas",
					m: "meses",
					y: "anos"
				}
			},
		},
		messages: {
			delete_confirmation: 'Excluir projeto',
			delete_confirmation_explanation:
				'Tem certeza de que deseja excluir o projeto «{{name}}»? Esta ação não pode ser desfeita.',
			clone_confirmation: 'Clonar projeto',
			clone_confirmation_explanation:
				'Tem certeza de que deseja clonar este projeto?',
			clone_in_progress: 'Clonando seu projeto, aguarde…',
			delete_in_progress: 'Excluindo seu projeto, aguarde…'
		},
		actions: {
			edit: 'Editar detalhes do projeto',
			delete: 'Excluir projeto',
			clone: 'Clonar projeto',
			open: 'Abrir projeto'
		}
	},
	option: {
		fields: {
			name_explanation: 'Digite um nome para esta opção'
		}
	},
	item: {
		name: 'Parte interessada',
		name_plural: 'Partes interessadas',
		activeness_zones: {
			external_outer_positive: 'Neutro',
			external_inner_positive: 'Inativo',
			external_outer_negative: 'Neutro',
			external_inner_negative: 'Inativo',
			internal_low_positive: 'Baixo',
			internal_medium_positive: 'Médio',
			internal_high_positive: 'Alto',
			internal_low_negative: 'Baixo',
			internal_medium_negative: 'Médio',
			internal_high_negative: 'Alto',
			internal_positive: 'Catalisadores',
			internal_negative: 'Inibidores'
		},
		messages: {
			delete_confirmation: 'Excluir parte interessada',
			delete_confirmation_explanation:
				'Tem certeza de que deseja excluir esta parte interessada? Ação irreversível e afeta todos os cenários.\n\nPara ocultar só neste cenário, feche, selecione a parte e na coluna direita clique no botão «olho» para desativar neste cenário.'
		},
		fields: {
			name: 'Nome',
			description: 'Descrição',
			links: {
				outcoming: { name: 'Vínculos de saída' },
				incoming: { name: 'Vínculos de entrada' }
			},
			stakes: { name: 'Relações com interesses' },
			indicators: { name: 'Relações com indicadores' },
			risks: { name: 'Relações com riscos' },
			opportunities: { name: 'Relações com aberturas' },
			impact: {
				label: 'Importância',
				level: { low: 'Baixa', medium: 'Média', high: 'Alta' }
			},
			trend: {
				label: 'Tonalidade',
				level: {
					green: 'Positivo',
					neutral: 'Neutro',
					orange: 'Em risco',
					red: 'Negativo'
				}
			}
		},
		actions: {
			create_new: 'Criar nova parte interessada',
			edit: 'Editar detalhes',
			delete: 'Excluir parte interessada',
			clone: 'Clonar parte interessada'
		},
		no_x: 'Nenhuma parte interessada',
		engagement: 'Engajamento',
		importance: 'Importância',
		trust: 'Tonalidade',
		levels: {
			low: 'Baixo',
			medium: 'Médio',
			high: 'Alto',
			inactive_neutral: 'Inativo / Neutro',
			positive: 'Positivo',
			positive_short: 'Pos.',
			negative: 'Negativo',
			negative_short: 'Neg.',
			at_risk: 'Em risco',
			neutral: 'Neutro'
		}
	},
	item_link: {
		no_x: 'Nenhum vínculo',
		actions: { create_new: 'Criar novo vínculo' }
	},
	item_comment: {
		no_x: 'Nenhum histórico',
		actions: { create_new: 'Criar novo histórico' }
	},
	tag: {
		name: 'Etiqueta',
		name_plural: 'Etiquetas',
		fields: { name: 'Etiqueta', name_plural: 'Etiquetas' },
		messages: {
			delete_confirmation: 'Excluir etiqueta',
			delete_confirmation_explanation:
				'Tem certeza de que deseja excluir esta etiqueta? Ação irreversível.',
			no_x: 'Nenhuma etiqueta'
		},
		actions: {
			add_x: 'Adicionar etiqueta',
			create_new: 'Criar etiqueta',
			edit: 'Editar etiqueta',
			delete: 'Excluir etiqueta'
		}
	},
	stake: {
		no_x: 'Nenhum interesse',
		name: 'Interesse',
		name_plural: 'Interesses',
		fields: {
			name: 'Nome',
			reference: 'Referência',
			name_plural: 'Interesses',
			description: 'Descrição',
			evaluated_at: 'Última avaliação',
			weight: 'Peso',
			trend: 'Status',
			risks: {
				name: 'Relações com riscos',
				name_positive: 'Relações com aberturas'
			},
			trend_tier: {
				strained: 'Precário',
				mixed: 'Misto',
				solid: 'Resiliente'
			}
		},
		message: { no_x: 'Nenhum interesse' },
		messages: {
			delete_confirmation: 'Excluir interesse',
			delete_confirmation_explanation:
				'Tem certeza de que deseja excluir este interesse? Ação irreversível e afeta todos os cenários.\n\nPara ocultar só neste cenário, feche, selecione o interesse e clique no «olho» à direita.'
		},
		actions: {
			delete: 'Excluir interesse',
			edit: 'Editar interesse',
			create_new: 'Criar interesse'
		}
	},
	indicator: {
		name: 'Indicador',
		name_plural: 'Indicadores',
		no_x: 'Nenhum indicador',
		fields: {
			indicator_category: 'Categoria',
			name: 'Nome',
			reference: 'Referência',
			name_plural: 'Indicadores',
			evaluated_at: 'Última avaliação',
			frequency: 'Frequência',
			weight: 'Peso',
			description: 'Descrição'
		},
		action: { add_x: 'Adicionar ponto de indicador' },
		message: { no_x: 'Nenhum indicador' },
		messages: {
			delete_confirmation: 'Excluir indicador',
			delete_confirmation_explanation:
				'Tem certeza de que deseja excluir este indicador? Ação irreversível e afeta todos os cenários.\n\nPara ocultar só neste cenário, feche, selecione e clique no «olho» à direita.'
		},
		actions: {
			delete: 'Excluir indicador',
			edit: 'Editar indicador',
			create_new: 'Criar indicador'
		}
	},
	scenario: {
		name: 'Cenário',
		name_plural: 'Cenários',
		no_x: 'Nenhum cenário',
		baseline: 'Linha de base',
		fields: {
			name: 'Nome',
			name_long: 'Nome do cenário',
			score: 'Pontuação do cenário',
			description: 'Descrição',
			impacts: 'Descrição dos impactos',
			generate_simulation: 'Gerar simulação automaticamente',
			simulation_query: 'Hipótese e horizonte temporal'
		},
		placeholders: {
			simulation_query:
				'Ex.: O que aconteceria se o petróleo subisse 50% em 2 anos? Consequências para partes interessadas e riscos?'
		},
		messages: {
			delete_confirmation: 'Excluir cenário',
			delete_confirmation_explanation:
				'Tem certeza de que deseja excluir este cenário? Ação irreversível.',
			switch_scenario: 'Ir para linha de base ou outro cenário',
			creation_in_progress: 'Aguarde enquanto o cenário é preparado…',
			simulation_explanation:
				'A IA analisará sua hipótese e proporá alterações em partes interessadas, riscos e interesses para simular o cenário.',
			promote_as_baseline: {
				title: 'Promover este cenário como nova linha de base',
				explanation:
					'Tem certeza de que deseja promover o cenário «<0>{{name}}</0>» como nova linha de base? Ação irreversível.',
				keep_current_baseline_as_scenario_question:
					'O que fazer com a linha de base anterior?',
				keep_current_baseline_as_scenario_question_yes:
					'Quero mantê-la com o seguinte nome',
				keep_current_baseline_as_scenario_question_no:
					'Nada, pode ser excluída',
				keep_scenario_question:
					'Deseja manter uma cópia do cenário agora promovido?',
				keep_scenario_question_yes: 'Sim, manter cópia',
				keep_scenario_question_no: 'Não preciso',
				loading: 'Promovendo cenário como nova linha de base…'
			},
			best_evaluation: 'Melhor caso entre todos os cenários'
		},
		actions: {
			create_new: 'Criar novo cenário',
			create_new_from_baseline: 'Criar cenário a partir da linha de base',
			save_as_new_baseline: 'Salvar como nova linha de base',
			clone: 'Clonar cenário',
			edit: 'Editar cenário',
			delete: 'Excluir cenário',
			next: 'Próximo cenário',
			previous: 'Cenário anterior',
			previous_baseline: 'Ir ao cenário de linha de base'
		}
	},
	fishbone_branch: {
		name: 'Osso',
		name_plural: 'Ossos',
		fields: {
			completion: 'Conclusão',
			trend: 'Status',
			name: 'Nome',
			description: 'Descrição',
			weight: 'Peso',
			responsible: 'Responsável',
			dates: 'Datas',
			startOn: 'Início',
			endOn: 'Fim'
		},
		messages: {
			delete_confirmation: 'Excluir ramo do plano estratégico',
			delete_confirmation_explanation:
				'Tem certeza de que deseja excluir este ramo? Ação irreversível e afeta todos os cenários.\n\nPara ocultar só neste cenário, feche, selecione o ramo e clique no «olho» à direita.'
		},
		actions: {
			add: 'Adicionar osso',
			clone: 'Clonar osso',
			edit: 'Editar osso',
			delete: 'Excluir osso'
		}
	},
	fishbone_item: {
		name: 'Sub-osso',
		name_plural: 'Sub-ossos',
		fields: {
			name: 'Nome',
			description: 'Descrição',
			completion: 'Conclusão',
			trend: 'Status',
			weight: 'Peso',
			responsible: 'Responsável',
			startOn: 'Início',
			endOn: 'Fim',
			dates: 'Datas'
		},
		messages: {
			delete_confirmation: 'Excluir sub-osso',
			delete_confirmation_explanation:
				'Tem certeza de que deseja excluir esta medida? Ação irreversível e afeta todos os cenários.\n\nPara ocultar só neste cenário, feche, selecione e clique no «olho» à direita.'
		},
		actions: {
			add: 'Adicionar sub-osso',
			clone: 'Clonar sub-osso',
			edit: 'Editar sub-osso',
			delete: 'Excluir sub-osso'
		}
	},
	risk: {
		name: 'Risco',
		name_plural: 'Riscos',
		name_positive: 'Abertura',
		name_plural_positive: 'Aberturas',
		fields: {
			name: 'Nome',
			description: 'Descrição - Indicadores de ocorrência',
			reference: 'Referência',
			risk_category: 'Categoria',
			likelihood: 'Probabilidade',
			likelihood_level: 'Nome do nível de probabilidade',
			impact: 'Impacto',
			impact_level: 'Nome do nível de impacto',
			matching_opportunity: 'Abertura correspondente',
			matching_risks: 'Riscos correspondentes',
			evaluated_at: 'Última avaliação',
			exposure: 'Exposição',
			exposure_positive: 'Potencial positivo',
			opportunity: { name: 'Abertura' }
		},
		impacts: {
			1: 'Insignificante',
			2: 'Menor',
			3: 'Moderado',
			4: 'Maior',
			5: 'Extremo'
		},
		likelihoods: {
			1: 'Muito improvável',
			2: 'Improvável',
			3: 'Possível',
			4: 'Provável',
			5: 'Quase certo'
		},
		messages: {
			delete_confirmation: 'Excluir risco',
			delete_confirmation_explanation:
				'Tem certeza de que deseja excluir este risco? Ação irreversível e afeta todos os cenários.\n\nPara ocultar só neste cenário, feche, selecione e clique no «olho» à direita.',
			delete_opening: 'Excluir abertura',
			delete_opening_explanation:
				'Tem certeza de que deseja excluir esta abertura? Ação irreversível e afeta todos os cenários.\n\nPara ocultar só neste cenário, feche, selecione e clique no «olho» à direita.',
			no_x: 'Nenhum risco',
			no_category: 'Nenhuma categoria',
			no_x_positive: 'Nenhuma abertura'
		},
		actions: {
			create_new: 'Criar novo risco ou abertura',
			edit: 'Editar risco',
			edit_opportunity: 'Editar abertura',
			delete: 'Excluir risco',
			delete_opportunity: 'Excluir abertura'
		}
	},
	risk_category: {
		name: 'Categoria',
		name_plural: 'Categorias',
		fields: { name: 'Nome' },
		messages: {
			delete_confirmation: 'Excluir categoria',
			delete_confirmation_explanation:
				'Tem certeza de que deseja excluir esta categoria? Ação irreversível.',
			no_x: 'Nenhuma categoria'
		},
		default_values: {
			name: {
				1: 'Existencial',
				2: 'Estratégica',
				3: 'Operacional'
			}
		},
		actions: {
			create_new: 'Criar nova categoria',
			edit: 'Editar categoria',
			delete: 'Excluir categoria',
			add_x: 'Adicionar categoria'
		}
	},
	indicator_category: {
		name: 'Categoria',
		name_plural: 'Categorias',
		fields: { name: 'Nome' },
		messages: {
			delete_confirmation: 'Excluir categoria',
			delete_confirmation_explanation:
				'Tem certeza de que deseja excluir esta categoria? Ação irreversível.',
			no_x: 'Nenhuma categoria',
			unassigned: 'Não atribuída'
		},
		default_values: {
			name: {
				1: 'Financeira',
				2: 'Clientes',
				3: 'Processos internos',
				4: 'Aprendizado e crescimento'
			}
		},
		actions: {
			create_new: 'Criar nova categoria',
			edit: 'Editar categoria',
			delete: 'Excluir categoria',
			add_x: 'Adicionar categoria'
		}
	},
};
